import { useEffect, useMemo } from "react";

interface ProjectThumbnailProps {
  blob?: Blob;
  orientation: "portrait" | "landscape" | "square";
}

export function ProjectThumbnail({ blob, orientation }: ProjectThumbnailProps) {
  const source = useMemo(() => (blob ? URL.createObjectURL(blob) : null), [blob]);

  useEffect(() => {
    return () => {
      if (source) URL.revokeObjectURL(source);
    };
  }, [source]);

  if (source) {
    return <img className="project-card__thumbnail" src={source} alt="" />;
  }

  return (
    <span className={`project-card__page project-card__page--${orientation}`} aria-hidden="true">
      <span className="project-card__scribble" />
    </span>
  );
}
